<template>
  <div class="container">
    <!-- 确认提示框 -->
    <el-dialog title="温馨提示" :visible.sync="dialogVisible" width="30%">
      <span>此时需要先登录才能继续操作哦</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="goLogin">去登录</el-button>
      </span>
    </el-dialog>

    <button @click="$router.go(-1)" class="goBack">
      <i class="el-icon-back"></i>返回
    </button>

    <div class="detailData">
      <img :src="obj.imgUrl" alt="" />
      <div class="detailContent">
        <h2>{{ obj.name }}</h2>
        <div class="description" v-html="obj.remark"></div>
        <div class="times">
          <div
            class="time"
            v-for="item in obj.interfacePackageList"
            :key="item.id"
            :class="{ active: item.id === activeItemId }"
            @click="timeConfirm(item.id)"
          >
            {{ item.times }}次
          </div>
        </div>

        <div class="priBox">
          <span class="price" ref="priceRef"></span>
          <span class="priceOriginal" ref="priceOriginalRef"></span>
          <span class="concurrent" ref="concurrentRef"></span>
        </div>

        <div class="buttonGroup">
          <button
            class="apply free"
            @click="applyFree"
            :disabled="obj.applyFree"
            :class="{ freeDisable: obj.applyFree }"
          >
            免费领取{{ obj.defaultCount }}次
          </button>
          <button class="apply pay" @click="apply">立即购买</button>
        </div>
      </div>
    </div>

    <div class="qrCode">
      <el-dialog
        title="支付二维码"
        :visible.sync="showDialog"
        width="40%"
        custom-class="custom-dialog"
        @close="closeDialog"
      >
        <div class="qr-code-container">
          <img :src="qrCodeUrl" alt="支付二维码" v-if="qrCodeUrl" />
          <p>请使用<span style="color: red; font-weight: 700;">“微信”</span>扫描二维码完成支付</p>
        </div>
        <span slot="footer" class="dialog-footer"> </span>
      </el-dialog>
    </div>

    <div class="apiDesc">
      <h1>API文档</h1>
      <div v-html="obj.apiDesc" class="content"></div>
    </div>
  </div>
</template>

<script>
import { detailInterface, applyInterface } from '@/api/common'
import { getByOrderNo, submit } from '@/api/pay'
import QRCode from 'qrcode'

export default {
  methods: {
    timeConfirm (id) {
      const item = this.obj.interfacePackageList.find((item) => item.id === id)
      if (item) {
        const domPrice = this.$refs.priceRef
        domPrice.innerHTML = '￥' + (item.price / 100).toFixed(2)
        const domOriginalPrice = this.$refs.priceOriginalRef
        domOriginalPrice.innerHTML = '￥' + (item.price / 0.8 / 100).toFixed(2)
        const domConcurrent = this.$refs.concurrentRef
        domConcurrent.innerHTML = '调用频率：' + item.concurrent + '次/秒'
      }
      this.activeItemId = id
    },
    callTimeConfirm () {
      // 确保 obj 和 interfacePackageList 存在且有内容
      if (
        this.obj &&
        this.obj.interfacePackageList &&
        this.obj.interfacePackageList.length > 0
      ) {
        const firstId = this.obj.interfacePackageList[0].id
        this.timeConfirm(firstId)
      } else {
        console.warn('interfacePackageList is undefined or empty.')
      }
    },
    async applyFree (event) {
      const token = this.$store.getters.token
      // 未登录
      if (!token) {
        this.dialogVisible = true
        return
      }
      // 调用获取方法
      const result = await applyInterface(this.$route.params.id)
      // 获取到按钮的dom对象，增加类
      event.target.classList.add('freeDisable')
      this.$toast.success(result.data)
    },
    async apply () {
      const token = this.$store.getters.token
      // 未登录
      if (!token) {
        this.dialogVisible = true
        return
      }
      const result = await submit(this.activeItemId)
      console.log(result)
      this.payObj = result.data

      try {
        const url = await QRCode.toDataURL(result.data.codeUrl)
        this.qrCodeUrl = url
      } catch (err) {
        console.error('生成二维码失败:', err)
      }
      this.showDialog = true

      // 开启定时器轮询查订单状态，若支付成功则关闭弹层，跳转到我的api页面
      this.timerId = setInterval(async () => {
        const orderObj = await getByOrderNo(result.data.orderNo)
        console.log(orderObj)
        if (orderObj && orderObj.data && orderObj.data.orderStatus === 60) {
          this.$toast.success('支付成功')
          this.showDialog = false
          clearInterval(this.timerId)
          this.$router.push('/myApi')
        }
      }, 2000)
    },
    closeDialog () {
      if (this.timerId) {
        console.log('关闭定时器：' + this.timerId)
        clearInterval(this.timerId)
      }
    },
    goLogin () {
      this.dialogVisible = false
      this.$router.replace({
        path: '/login',
        query: {
          backUrl: this.$route.fullPath
        }
      })
    }
  },
  data () {
    return {
      obj: {},
      activeItemId: null,
      dialogVisible: false,
      payObj: {},
      qrCodeUrl: null,
      showDialog: false,
      timerId: null
    }
  },
  async created () {
    const id = this.$route.params.id
    const userId = this.$store.getters.getUserId
    const result = await detailInterface(id, userId || null)
    this.obj = result.data
    // 在数据加载完成后立即调用 timeConfirm
    this.callTimeConfirm()
  },
  destroyed () {
    if (this.timerId) {
      console.log('关闭定时器：' + this.timerId)
      clearInterval(this.timerId)
    }
  }
}
</script>

<style lang="less">
// 清新蓝色主题色
@primary: #1890ff;
@success: #52c41a;
@text: #333;
@text-light: #666;
@border: #e8e8e8;
@bg-light: #f5f5f5;

// 返回按钮
.goBack {
  padding: 8px 18px;
  margin-top: 20px;
  background: @primary;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;

  &:hover {
    background: #40a9ff;
  }

  i {
    margin-right: 4px;
  }
}

// 详情卡片
.detailData {
  background: #fff;
  min-height: 340px;
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 30px 40px;
  border-radius: 8px;
  border: 1px solid @border;

  img {
    width: 210px;
    height: 210px;
    border-radius: 8px;
    object-fit: cover;
  }

  .detailContent {
    width: 800px;
    padding: 0 30px;

    h2 {
      font-size: 24px;
      font-weight: 600;
      color: @text;
      margin-bottom: 12px;
    }

    .description {
      color: @text-light;
      font-size: 14px;
      line-height: 1.8;
      margin: 15px 0;
      max-height: 80px;
      overflow: hidden;
    }

    .times {
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;
      gap: 10px;

      .time {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 8px 18px;
        border: 1px solid @border;
        border-radius: 4px;
        cursor: pointer;
        color: @text-light;
        font-size: 14px;
        transition: all 0.2s;

        &:hover {
          border-color: @primary;
          color: @primary;
        }
      }

      .active {
        border-color: @primary;
        background: @primary;
        color: #fff;

        &:hover {
          border-color: @primary;
          color: #fff;
        }
      }
    }

    .priBox {
      margin-top: 18px;
      display: flex;
      align-items: baseline;
      gap: 12px;

      .price {
        font-size: 28px;
        font-weight: 600;
        color: #ff4d4f;
      }

      .priceOriginal {
        text-decoration: line-through;
        font-size: 14px;
        color: #999;
      }

      .concurrent {
        font-size: 14px;
        color: #ff9900;
        font-weight: 700;
      }
    }

    .buttonGroup {
      margin-top: 22px;
      display: flex;
      gap: 12px;
    }

    .apply {
      width: 130px;
      height: 40px;
      line-height: 40px;
      padding: 0;
      font-size: 14px;
      font-weight: 500;
      text-align: center;
      border-radius: 4px;
      cursor: pointer;
      border: none;
      transition: all 0.2s;

      &.free {
        background: @success;
        color: #fff;

        &:hover:not(:disabled) {
          background: #73d13d;
        }
      }

      &.pay {
        background: @primary;
        color: #fff;

        &:hover {
          background: #40a9ff;
        }
      }

      &.freeDisable {
        background: #ccc;
        cursor: not-allowed;
      }

      &:disabled {
        cursor: not-allowed;
      }
    }
  }
}

// API文档区域
.apiDesc {
  margin: 30px 0;
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  border: 1px solid @border;

  h1 {
    font-size: 20px;
    font-weight: 600;
    color: @text;
    margin-bottom: 20px;
  }

  .content {
    margin-top: 20px;

    .interfaceDesc {
      color: @text;
      font-size: 14px;
      line-height: 1.8;
      background: @bg-light;
      padding: 15px;
      border-radius: 4px;

      p {
        margin: 5px 0;

        a {
          color: @primary;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }

    h3 {
      margin: 18px 0 12px;
      font-size: 15px;
      font-weight: 600;
      color: @text;
    }

    .parameterDesc,
    .returnParameterDesc {
      width: 100%;
      border: 1px solid @border;
      border-collapse: collapse;
      color: @text-light;
      font-size: 13px;

      th,
      td {
        border: 1px solid @border;
        padding: 10px 12px;
        text-align: left;
      }

      th {
        background: @bg-light;
        font-weight: 600;
        white-space: nowrap;
      }
    }

    pre {
      background: #fafafa;
      border: 1px solid @border;
      border-radius: 4px;
      padding: 12px;
      white-space: pre-wrap;
      word-wrap: break-word;
      font-family: monospace;
      font-size: 13px;
      line-height: 1.5;
      color: @text;
      overflow-x: auto;
    }
  }
}

// 弹窗样式 - 只作用于当前页面的弹窗
.container {
  .el-dialog {
    max-width: calc(100vw - 40px);
  }
}

.qrCode {
  .qr-code-container {
    text-align: center;
    padding: 10px;

    img {
      width: 180px;
      height: 180px;
      margin-bottom: 15px;
    }

    p {
      font-size: 14px;
      color: @text-light;

      span {
        color: #07c160;
        font-weight: 600;
      }
    }
  }

  .custom-dialog {
    border-radius: 8px !important;
  }
}

// 登录提示弹窗
.el-dialog__header {
  background: @primary;

  .el-dialog__title {
    color: #fff;
    font-size: 16px;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
  }
}

.el-dialog__body {
  padding: 20px 25px;
  font-size: 14px;
  color: @text;
}

// 响应式
@media screen and (max-width: 768px) {
  .container {
    padding: 0 12px;
  }

  .goBack {
    margin-top: 12px;
    padding: 6px 14px;
    font-size: 13px;
  }

  .detailData {
    flex-direction: column;
    padding: 15px;
    margin-top: 15px;

    img {
      width: 140px;
      height: 140px;
    }

    .detailContent {
      width: 100%;
      padding: 15px 0 0 0;
      margin-top: 0;

      h2 {
        font-size: 18px;
      }

      .description {
        font-size: 13px;
        margin: 10px 0;
      }

      .times {
        margin-top: 15px;

        .time {
          padding: 6px 14px;
          font-size: 12px;
        }
      }

      .priBox {
        gap: 8px;

        .price {
          font-size: 22px;
        }

        .priceOriginal {
          font-size: 12px;
        }

        .concurrent {
          font-size: 12px;
        }
      }

      .buttonGroup {
        flex-direction: column;
        gap: 10px;
      }

      .apply {
        width: 100%;
        height: 38px;
        line-height: 38px;
        font-size: 14px;
      }
    }
  }

  .apiDesc {
    margin: 20px 0;
    padding: 20px;

    h1 {
      font-size: 18px;
      margin-bottom: 15px;
    }

    .content {
      .parameterDesc,
      .returnParameterDesc {
        display: block;
        overflow-x: auto;
        font-size: 12px;
      }

      pre {
        font-size: 12px;
        padding: 10px;
      }
    }
  }

  .qrCode {
    .qr-code-container {
      img {
        width: 140px;
        height: 140px;
      }
      p {
        font-size: 13px;
      }
    }
  }
}

// 简单淡入动画
.container {
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
<style lang="less" scoped>
.detailData { min-height: 280px; padding: 24px; gap: 20px; }
.detailData .detailContent { width: auto; min-width: 0; flex: 1; padding: 0; }
.detailData > img { width: 160px; height: 160px; flex-shrink: 0; }
.apiDesc { margin: 20px 0; padding: 20px; }
@media screen and (max-width: 768px) {
  .detailData { padding: 16px; gap: 12px; }
  .detailData > img { width: 80px; height: 80px; }
  .detailData .detailContent { width: 100%; }
  .detailData .detailContent h2 { font-size: 20px; }
  .apiDesc { padding: 14px; margin: 14px 0; }
}
</style>
